import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="case_studies" pageTitle="Case Studies" pageDescription="Real-world examples of how QbD Group helps life sciences companies navigate regulatory challenges and accelerate market launch." />;

export const Route = createFileRoute("/en/case-studies/")({
  head: () => buildRouteHead("/en/case-studies"),
  component: ContentListingRoute,
});

